import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "car_models",
        object: "car_model",
        header: [
            { text: "Nombre", value: "name" },
            { text: "Imagen", value: "car_picture", sortable: false},
            // { text: "Colores", value: "car_colors"},
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
